/**
 * URL-scheme handler for iOS Siri Shortcuts (no native Xcode required).
 *
 * The user creates a Shortcut in the Shortcuts app:
 *   1. New Shortcut → "Get text from Speech" (dictation) → outputs text
 *   2. → "Open URL" → babyos-shortcut:///log?utterance={Speech text}
 *
 * The web PWA registers as a handler for the babyos-shortcut:// scheme via
 * `registerProtocolHandler` on install. When Shortcuts opens the URL, the PWA
 * loads /log?utterance=... which parses the utterance via the existing NLP
 * pipeline and lands on the confirm screen.
 *
 * Fallback: web-based Web Share Target could also register, but URL scheme is
 * more reliable on iOS Shortcuts.
 */

export function registerShortcutProtocol(): void {
  if (typeof navigator === 'undefined') return
  const nav = navigator as unknown as { registerProtocolHandler?: (scheme: string, url: string) => void }
  if (!nav.registerProtocolHandler) return
  try {
    // Only web+scheme prefixes allowed for arbitrary origins per spec — that's fine
    nav.registerProtocolHandler('web+babyos', `${location.origin}/ask?utterance=%s&auto=1`)
  } catch { /* browser refused — no-op */ }
}
